import { PatientPrescriptions } from '@pages/Prescriptions'

export default function Prescriptions({ patient }) {
  return <PatientPrescriptions.Inline patientId={patient?.id} variant="outlined" disableRowsPerPage perPage={5} />
}
